import {Component, Input, OnInit} from '@angular/core';
import {ScheduledSequenceConfig} from '../../../../model/sequence';


@Component({
  selector: 'app-sequence-schedule-card',
  templateUrl: './sequence-schedule-card.component.html',
  styleUrls: ['./sequence-schedule-card.component.scss']
})
export class SequenceScheduleCardComponent implements OnInit {
  @Input() scheduledSequenceConfig: ScheduledSequenceConfig;
  @Input() hover: boolean;

  scheduledTime: number;
  isAtLeastOneDayScheduled: boolean;

  ngOnInit(): void {
    this.scheduledTime = this.getDate();
    this.isAtLeastOneDayScheduled = this.scheduledSequenceConfig.monday ||
      this.scheduledSequenceConfig.tuesday ||
      this.scheduledSequenceConfig.wednesday ||
      this.scheduledSequenceConfig.thursday ||
      this.scheduledSequenceConfig.friday ||
      this.scheduledSequenceConfig.saturday ||
      this.scheduledSequenceConfig.sunday;
  }

  getDate(): number {
    const date: Date = new Date();
    date.setUTCHours(this.scheduledSequenceConfig.startHour);
    date.setUTCMinutes(this.scheduledSequenceConfig.startMinute);
    return date.getTime();
  }
}
